import debounce from 'lodash/debounce';
import camelCase from 'lodash/camelCase';
import chunk from 'lodash/chunk';
import head from 'lodash/head';

export default {
  debounce,
  camelCase,
  chunk,
  head,
};
